import { Injectable } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { ErrorModalComponent } from './error-modal.component';

@Injectable()
export class AlertService {

  constructor(private modal: NgbModal) {
  };

  public errorModal(msg: string): void {
      const dialog = this.modal.open(ErrorModalComponent);
      if (dialog) {
          dialog.componentInstance.message = msg;
      }
  };

  public globalError(data: any): void {
      if (data.hasOwnProperty('error') && data.error > 0) {
          let msg = 'При выполнении операции произошла ошибка';
          this.errorModal(msg);
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/alert/alert.service.ts